export const dark ={
    palette: {
        type: 'dark',
        primary: {
            main: '#4fc3f7'
        }
    }
};


export const light = { 
    palette: {
        type: 'light',
        background: {
            // paper: 'rgba(255,255,255,0.4)',
        },
        primary: {
            main: '#283593'
        }
    }
};
